import { render, staticRenderFns } from "./EventsPage.vue?vue&type=template&id=3e4e685f&scoped=true&lang=pug"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=3e4e685f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e685f",
  null
  
)

export default component.exports